// ViolationsCard.js
import React, { useState } from 'react';
import { Box, Button, ButtonGroup, IconButton, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import RenderFields from '../Renders/RenderFields';
import API_BASE_URL from '../../../../../../Constants';

const ViolationsCard = ({
  assignedInspections,
  violationFields,
  isEditMode,
  updateViolation,
  handleChange,
  setViolations,
  selectedViolation,
  setSelectedViolation,
}) => {
  const [loading, setLoading] = useState(false);
  const [violations, setLocalViolations] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleInspectionClick = async (inspection) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/violations/byInspection/${inspection.inspectionId}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        }
      );
      if (!response.ok) {
        throw new Error('Failed to fetch violations');
      }
      const data = await response.json();
      setViolations(data || []);
      setLocalViolations(data || []);
      if (data && data.length > 0) {
        setSelectedViolation(data[0]);
        setCurrentIndex(0);
      } else {
        setSelectedViolation(null);
        setCurrentIndex(0);
      }
    } catch (error) {
      console.error('Error fetching violations:', error);
      setViolations([]);
      setLocalViolations([]);
      setSelectedViolation(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLocalFieldChange = (e) => {
    handleChange(e, selectedViolation, setSelectedViolation);
  };

  const handleNextViolation = () => {
    if (currentIndex < violations.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setSelectedViolation(violations[currentIndex + 1]);
    }
  };

  const handlePrevViolation = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setSelectedViolation(violations[currentIndex - 1]);
    }
  };

  return (
    <Box mb={2}>
      <h3 className="text-xl font-bold mb-2">Violations</h3>
      {assignedInspections.length > 0 ? (
        <Box className="flex mb-4">
          <ButtonGroup orientation="vertical">
            {assignedInspections.map((inspection) => (
              <Button
                key={inspection.inspectionId}
                onClick={() => handleInspectionClick(inspection)}
                variant={
                  selectedViolation && inspection.inspectionId === selectedViolation.inspectionId
                    ? 'contained'
                    : 'outlined'
                }
              >
                {inspection.inspectionId}
              </Button>
            ))}
          </ButtonGroup>
          <Box ml={4}>
            {loading ? (
              <p>Loading violations...</p>
            ) : !selectedViolation ? (
              <p className="text-gray-500 italic">No violations for this Inspection.</p>
            ) : (
              <>
                <Typography variant="h6" className="mb-2">
                  Violation {currentIndex + 1} of {violations.length}
                </Typography>
                <RenderFields
                  fields={violationFields}
                  formData={selectedViolation}
                  handleChange={isEditMode ? handleLocalFieldChange : undefined}
                  readOnly={!isEditMode}
                />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                  <IconButton onClick={handlePrevViolation} disabled={currentIndex === 0}>
                    <ArrowBack />
                  </IconButton>
                  <IconButton
                    onClick={handleNextViolation}
                    disabled={currentIndex === violations.length - 1}
                  >
                    <ArrowForward />
                  </IconButton>
                </Box>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <p>No inspections assigned to this building.</p>
      )}
      {isEditMode && selectedViolation && (
        <Button variant="contained" color="primary" onClick={() => updateViolation(selectedViolation)}>
          Submit Changes
        </Button>
      )}
    </Box>
  );
};

export default ViolationsCard;